import { createRoutine } from 'redux-saga-routines';

import extendRoutine from 'utils/extendRoutines';

import { GET_ROLE, SAVE_ROLE } from './constants';

export const getRole = extendRoutine(createRoutine(GET_ROLE), 'RESET');

export const saveRole = extendRoutine(createRoutine(SAVE_ROLE), 'RESET');
